<template>
  <div class="timeline-wrapper">
    <div class="timeline-item">
      <div class="animated-background">
        <div class="background-masker header-top"></div>
        <div class="background-masker header-left"></div>
        <div class="background-masker header-right"></div>
        <div class="background-masker header-bottom"></div>
        <div class="background-masker subheader-left"></div>
        <div class="background-masker subheader-right"></div>
        <div class="background-masker subheader-bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loading'
  }
</script>
